import { useSelector } from 'react-redux';

export const useFilterParamsSelector = () => useSelector(state => state.filter.filterParams);
